module.exports = __webpack_public_path__ + "img/addres_bg.4c1a6613.png";